/*
 * gs-product-gallery.js
 *
 * Arrows and thumbnails for gs-product-gallery. The track is a native
 * scroll-snap strip, so swiping works with no script at all; this file only
 * adds the buttons and keeps the active thumbnail in step with the photo shown.
 * Scoped to each [data-gs-gallery] root.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.hasAttribute('data-gs-gallery-ready')) return;
    root.setAttribute('data-gs-gallery-ready', '');

    var track = root.querySelector('[data-gs-gallery-track]');
    if (!track) return;
    var slides = root.querySelectorAll('[data-gs-gallery-slide]');
    var thumbs = root.querySelectorAll('[data-gs-gallery-thumb]');
    var current = 0;

    function show(i) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    function mark(i) {
      current = i;
      thumbs.forEach(function (t, ti) {
        var on = ti === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        show(parseInt(t.getAttribute('data-gs-gallery-thumb'), 10) || 0);
      });
    });

    var prev = root.querySelector('[data-gs-gallery-prev]');
    var next = root.querySelector('[data-gs-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    var pending = null;
    track.addEventListener('scroll', function () {
      if (pending) return;
      pending = window.requestAnimationFrame(function () {
        pending = null;
        var w = track.clientWidth || 1;
        mark(Math.round(track.scrollLeft / w));
      });
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-gs-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-gs-gallery]').forEach(init);
  });
})();
